import React from "react";
import { useState, useEffect, useRef } from "react";

type Props = {
  locked: boolean;
  setLocked: Function;
};
function LockUnlock(props: Props) {
  return (
    <>
      {props.locked == false ? (
        <a
          className="btn-primary"
          title="Click to lock"
          onClick={() => props.setLocked(true)}
        >
          <img
            src="images/un-lock.svg"
            width="13px"
            height="15px"
            alt="unlock"
          />
        </a>
      ) : (
        <a
          className="btn-primary"
          title="Click to un-lock"
          onClick={() => props.setLocked(false)}
        >
          <img
            src="images/lock-w.svg"
            width="13px"
            height="15px"
            alt="unlock"
          />
        </a>
      )}
    </>
  );
}

export default LockUnlock;
